import { gql } from '@apollo/client'

export const GET_SKIPTRACE_FUNDS_INFO_GQL = gql(/** GraphQL */`
  query GetSkiptraceFundsInfo {
    myEnterprise {
      id
      wallet {
        balance {
          available
        }
      }
      subscription {
        ... on BillingSubscriptionActive {
          currentPeriod {
            end
          }
          plan {
            name
            product {
              features {
                ... on SubscriptionFeatureSkiptrace {
                  __typename
                  prices {
                    price
                  }
                }
                ... on SubscriptionFeatureIndividualSkiptrace {
                  __typename
                  limits {
                    interval
                    value
                  }
                  prices {
                    price
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`)
